import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  Renderer2,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  AbstractControl,
  ValidatorFn,
  FormArray,
} from "@angular/forms";
import { Subject, Subscription } from "rxjs";
import { EventService } from "src/app/core/services/event.service";
import { PropertiesService } from "../../services/properties.services";
import {
  debounceTime,
  distinctUntilChanged,
  auditTime,
  takeUntil,
} from "rxjs/operators";
import { AuthService } from "src/app/core/services/auth.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { environment } from "src/environments/environment";
import { PermissionsService } from "src/app/core/services/permissions.service";
import Swal from "sweetalert2";
import { TranslateService } from "@ngx-translate/core";
import { ToastService } from "src/app/shared/toasts/toast-service";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { PaymentConditionsModel } from "../../models/payment-conditions.model";
import { PropertyDataService } from "src/app/core/services/property-data.service";
import { EntityService } from "src/app/pages/entity/services/entity.service";
import { PropertyRuleField } from "../../../entity/config/properties/models/property-validation-rules";
import { PropertyValidationRulesService } from "src/app/core/services/propertyValidationRules.service";

@Component({
  selector: "app-details",
  templateUrl: "./details.component.html",
  styleUrls: ["./details.component.scss"],
})
export class DetailsComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() detailsForm: any;
  @Input() allAgents: any;
  @Input() dataToFormInitDetails: any;
  @Input() quantityAvailable!: number;
  @Input() agents: any;
  @Input() propertyAgentsData: any;
  @Input() canChangeBusinessStatus: any;
  @Input() isUpdate: boolean = false;
  @Input() property: any;
  @Input() prospectingId: any;
  @Input() submitted: boolean = false;
  @Input() minimumCommissionValidation: {
    active: boolean;
    minimum: number | null;
    action: "BLOCK_SAVE" | "SEND_TO_MASTER_VALIDATION";
  } | null = null;

  @Output() agentsChange: EventEmitter<any> = new EventEmitter<any>();

  paymentsConditions?: PaymentConditionsModel[];

  stores: any;
  propertyTypes: any;
  conditions: any;
  businessStatus: any;
  saleId: any;
  typeRent: any;
  rentIds!: any[];
  ec: any;
  businessTypes: any;
  currencies: any;
  subscription!: Subscription;
  subscriptionSubmitted!: Subscription;
  aiExtractedSub?: Subscription;
  propertyDetailsForm!: FormGroup;

  selectDefaultStore: any;
  type: number = 0;
  propertyTypes2: any;
  isPropertyType = false;
  properties: any = [];
  isView = false;
  legislations: any;

  isNproperty = false;
  isRefValid = true;
  ref = "";
  isShowUseLicense = false;
  nproperties: any = [];
  @ViewChildren("inputRefp") myInputs!: QueryList<ElementRef>;
  @ViewChildren("ngselectRefp") mySelects!: QueryList<ElementRef>;
  @ViewChild("formElementRef") formElementRef!: ElementRef;
  @ViewChild("content") content: any;
  @ViewChild("contentRent") contentRent: any;
  queryField = new FormControl();
  pathProfileImage = `${environment.apiUrl}/${environment.dirProfileImage}/`;
  securityForm: any;
  autoReference!: string;
  oldStore: any;
  subscriptionUpdateSore!: Subscription;
  storeChangeResult: any;
  openNewAgent: { listing: boolean; selling: boolean } = {
    listing: false,
    selling: false,
  };
  selected: { listing: any; selling: any } = { listing: null, selling: null };
  agentsExceptListing: any[] = [];
  agentsExceptSelling: any[] = [];
  saleFormGetAgentsFn = (type: "listing" | "selling") => this.getAgents(type);
  saleFormGetStoreByIdFn = (id: any) => this.getStoreById(id);
  saleFormGetSuffixFn = () => this.getSuffix();
  requiredDealForSale = false;
  requiredSellerForSale = false;
  private sellerRequiredWarningShown = false;
  platePlacementMinDate: Date | any = null;

  private destroy$ = new Subject<void>();

  constructor(
    private eventService: EventService,
    private formBuilder: FormBuilder,
    private propertiesService: PropertiesService,
    private cdr: ChangeDetectorRef,
    public authService: AuthService,
    private modalService: NgbModal,
    private renderer: Renderer2,
    public permissionsService: PermissionsService,
    public translate: TranslateService,
    private propertyData: PropertyDataService,
    private toastService: ToastService,
    private entityService: EntityService,
    private propertyValidationService: PropertyValidationRulesService,
  ) {
    this.subscription = new Subscription();
  }

  ngOnInit(): void {
    this.platePlacementMinDate = this.resolvePlatePlacementMinDate();
    // O interruptor "diretores de loja atuam como consultores" vem também nas
    // preferências da entidade: refresca a cópia do user-auth para apanhar
    // uma alteração do MASTER sem recarregar a app. Só quando a chave existe.
    const entityPreferences = this.dataToFormInitDetails?.entityPreferences;
    if (
      entityPreferences &&
      typeof entityPreferences.storeOperatorActsAsConsultant === "boolean"
    ) {
      this.permissionsService.refreshEntityFlags({
        storeOperatorActsAsConsultant:
          entityPreferences.storeOperatorActsAsConsultant,
      });
    }
    this.stores = this.dataToFormInitDetails?.stores;
    this.propertyTypes = this.dataToFormInitDetails?.propertyTypes;
    this.conditions = this.dataToFormInitDetails?.conditions;
    this.businessStatus = this.dataToFormInitDetails?.businessStatus;
    this.saleId = this.dataToFormInitDetails?.saleId;
    this.rentIds = this.dataToFormInitDetails?.rentIds;
    this.typeRent = this.dataToFormInitDetails?.typeRent;
    this.ec = this.dataToFormInitDetails?.ec;
    this.businessTypes = this.dataToFormInitDetails?.businessTypes;
    this.currencies = this.dataToFormInitDetails?.currencies;
    this.selectDefaultStore = this.stores[0];

    if (this.quantityAvailable > 10) {
      for (let index = 0; index <= 50; index++) {
        this.nproperties.push(index);
      }
    } else {
      for (let index = 0; index < this.quantityAvailable; index++) {
        this.nproperties.push(index);
      }
    }

    this.refreshListings();
    this.loadEntitySettings();

    this.initFormValidation();

    this.propertyValidationService
      .rules$()
      .pipe(takeUntil(this.destroy$))
      .subscribe((map) => {
        if (!map?.size || !this.propertyDetailsForm) return;

        const revalidateTree = (ctrl: AbstractControl) => {
          if (ctrl instanceof FormGroup) {
            Object.values(ctrl.controls).forEach(revalidateTree);
          } else if (ctrl instanceof FormArray) {
            ctrl.controls.forEach(revalidateTree);
          }

          ctrl.updateValueAndValidity({ emitEvent: false });
        };

        revalidateTree(this.propertyDetailsForm);
      });

    this.propertyDetailsForm.valueChanges
      .pipe(auditTime(150), takeUntil(this.destroy$))
      .subscribe((data) => {
        this.detailsForm.data = data;
        this.detailsForm.errors = this.getFormErrors();
        this.detailsForm.valid = this.propertyDetailsForm.valid;

        this.eventService.broadcast("check-warning-add-property");
      });

    this.propertyDetailsForm.valueChanges
      .pipe(auditTime(150))
      .subscribe((val) =>
        this.propertyData.updateTab(
          "details",
          this.buildDetailsForAiContext(val),
        ),
      );

    this.propertyData.updateTab(
      "details",
      this.buildDetailsForAiContext(this.propertyDetailsForm.getRawValue()),
    );

    this.eventService.subscribe("refresh-reference", (ref) =>
      this.propertyDetailsForm.patchValue(
        { reference: ref, isTempReference: false },
        { emitEvent: false },
      ),
    );
  }

  ngAfterViewInit(): void {
    if (!this.subscriptionSubmitted)
      this.subscriptionSubmitted = this.eventService.subscribe(
        "get-data-tab-details",
        () => {
          this.getTabDetails();
        },
      );

    const openSaleFormSub = this.eventService.subscribe(
      "open-sale-form-required-deal",
      () => {
        this.openSaleDetailsModal();
      },
    );
    this.subscription.add(openSaleFormSub);

    // reference digitada pelo usuário → valida unicidade
    const refSub = this.propertyDetailsForm
      .get("reference")
      ?.valueChanges.pipe(debounceTime(200))
      .subscribe((data) => {
        this.ref = data?.trim();

        setTimeout(() => {
          if (this.isRefValid) {
            this.checkReference();
          } else {
            this.isRefValid = true;
          }

          this.getTabDetails();
        });
      });

    this.subscription.add(refSub);

    // (2) Store mudou → gera preview automático
    this.propertyDetailsForm
      .get("store")
      ?.valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(() => {
        this.checkReference();
      });

    // (3) PropertyType mudou → gera preview automático
    this.propertyDetailsForm
      .get("propertyType")
      ?.valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(() => {
        this.checkReference();

        this.eventService.broadcast("get-data-tab-details");
      });

    this.onChangeEC({ id: this.detailsForm?.data?.ec });

    this.submitted = true;

    this.isView = true;

    this.oldStore = this.propertyDetailsForm.get("store")?.value;

    this.checkReference();

    // O antigo disableEndDate() saiu: esperava por "#endDateMediation", que já
    // não existe nesta ficha (o campo migrou para o app-mediation-contract).
    // Como o elemento nunca aparecia, cada abertura do modal deixava um
    // MutationObserver ligado ao document.body para sempre — e cada um
    // convertia qualquer mutação de DOM da página num tick de change
    // detection, acumulando até degradar/congelar o browser.

    const dateOfConstruction =
      this.propertyDetailsForm.get("yearOfConstruction")?.value;
    if (
      dateOfConstruction &&
      dateOfConstruction !== "" &&
      new Date(dateOfConstruction) > new Date("1951-08-07")
    ) {
      this.isShowUseLicense = true;
    } else {
      this.isShowUseLicense = false;
    }

    this.cdr.detectChanges();

    this.setEletemtConfig();

    this.propertyDetailsForm
      .get("businessType")
      ?.valueChanges.subscribe((data) => {
        if (!this.property?.saleInProgress)
          this.eventService.broadcast("get-data-tab-details");
      });

    this.propertyDetailsForm
      .get("condition")
      ?.valueChanges.subscribe((data) => {
        this.eventService.broadcast("get-data-tab-details");
      });

    this.propertyDetailsForm
      .get("businessStatus")
      ?.valueChanges.subscribe((data) => {
        if (this.canChangeBusinessStatus && !this.property?.saleInProgress)
          this.eventService.broadcast("get-data-tab-details");
      });

    this.propertyDetailsForm.get("ec")?.valueChanges.subscribe((data) => {
      this.propertyDetailsForm.get("ecNumber")?.updateValueAndValidity();
      this.eventService.broadcast("get-data-tab-details");
    });

    this.propertyDetailsForm.get("price")?.valueChanges.subscribe((data) => {
      this.eventService.broadcast("get-data-tab-details");
    });

    this.propertyDetailsForm
      .get("propertyType2")
      ?.valueChanges.subscribe((data) => {
        this.eventService.broadcast("get-data-tab-details");
      });

    this.propertyDetailsForm
      .get("associatedProperty")
      ?.valueChanges.subscribe((data) => {
        this.eventService.broadcast("get-data-tab-details");
      });

    this.propertyDetailsForm
      .get("yearOfConstruction")
      ?.valueChanges.subscribe((data) => {
        if (data && data !== "" && new Date(data) > new Date("1951-08-07")) {
          this.isShowUseLicense = true;
        } else {
          this.isShowUseLicense = false;
        }
      });

    this.propertyDetailsForm
      .get("contractNumber")
      ?.valueChanges.subscribe((data) => {
        this.eventService.broadcast("get-data-tab-details");
      });

    this.propertyDetailsForm
      .get("statusRegisterBook")
      ?.valueChanges.subscribe((data) => {
        this.eventService.broadcast("get-data-tab-details");
      });

    this.aiExtractedSub = this.eventService.subscribe(
      "ai-doc-extracted",
      (data: any) => {
        this.applyAiExtraction(data);
      },
    );
  }

  private applyAiExtraction(data: any) {
    if (!data || !this.propertyDetailsForm) return;

    const patch: any = {};
    const animatedFields: string[] = [];

    if (data.yearOfConstruction) {
      patch.yearOfConstruction = new Date(`${data.yearOfConstruction}-01-01`);
      animatedFields.push("yearOfConstruction");
    }

    if (data.ecNumber) {
      patch.ecNumber = data.ecNumber;
      animatedFields.push("ecNumber");
    }
    if (data.ecExpirationDate) {
      patch.ecExpirationDate = this.coerceAiDate(data.ecExpirationDate);
      animatedFields.push("ecExpirationDate");
    }
    if (data.renewableEnergy !== undefined && data.renewableEnergy !== null) {
      patch.renewableEnergy = data.renewableEnergy;
      animatedFields.push("renewableEnergy");
    }
    if (data.carbonEmissions !== undefined && data.carbonEmissions !== null) {
      patch.carbonEmissions = data.carbonEmissions;
      animatedFields.push("carbonEmissions");
    }
    if (data.useLicense) {
      patch.useLicense = data.useLicense;
      animatedFields.push("useLicense");
    }
    if (data.buildingLicense) {
      patch.buildingLicense = data.buildingLicense;
      animatedFields.push("buildingLicense");
    }
    if (data.dateLicense) {
      patch.dateLicense = this.coerceAiDate(data.dateLicense);
      animatedFields.push("dateLicense");
    }
    if (data.technicalSheetLicense) {
      patch.technicalSheetLicense = data.technicalSheetLicense;
      animatedFields.push("technicalSheetLicense");
    }
    if (data.propertyValue !== undefined && data.propertyValue !== null) {
      patch.propertyValue = data.propertyValue;
      animatedFields.push("propertyValue");
    }
    if (
      data.price !== undefined &&
      data.price !== null &&
      !this.propertyDetailsForm.get("price")?.value
    ) {
      patch.price = data.price;
      animatedFields.push("price");
    }

    if (data.ecCode && Array.isArray(this.ec)) {
      const ec = this.ec.find((item: any) => {
        const key = String(item?.key ?? "").toLowerCase();
        const desc = String(item?.description ?? "").toLowerCase();
        const wanted = String(data.ecCode).toLowerCase();
        return key === wanted || desc.includes(wanted);
      });
      if (ec?.id) {
        patch.ec = ec.id;
        animatedFields.push("ec");
      }
    }

    const propertyTypeText = data?.propertyType ?? data?.typology;
    if (propertyTypeText && Array.isArray(this.propertyTypes)) {
      const propertyTypeId = this.resolveOptionIdByText(
        this.propertyTypes,
        propertyTypeText,
      );
      if (propertyTypeId) {
        patch.propertyType = propertyTypeId;
        animatedFields.push("propertyType");
      }
    }

    if (data?.condition && Array.isArray(this.conditions)) {
      const conditionId = this.resolveOptionIdByText(
        this.conditions,
        data.condition,
      );
      if (conditionId) {
        patch.condition = conditionId;
        animatedFields.push("condition");
      }
    }

    if (Object.keys(patch).length === 0) return;

    this.propertyDetailsForm.patchValue(patch);
    this.detailsForm.data = this.propertyDetailsForm.value;
    this.detailsForm.errors = this.getFormErrors();
    this.detailsForm.valid = this.propertyDetailsForm.valid;
    this.eventService.broadcast("check-warning-add-property");

    this.highlightAiFields(animatedFields);
  }

  private coerceAiDate(value: any): any {
    if (!value) return value;
    if (value instanceof Date) return value;
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? value : date;
  }

  private resolveOptionIdByText(list: any[], value: any): number | undefined {
    const wanted = this.normalizeAiText(value);
    if (!wanted || !Array.isArray(list)) return undefined;

    const exact = list.find((item: any) => {
      const description = this.normalizeAiText(item?.description);
      const key = this.normalizeAiText(item?.key);
      const name = this.normalizeAiText(item?.name);
      return description === wanted || key === wanted || name === wanted;
    });
    if (exact?.id) return Number(exact.id);

    const partial = list.find((item: any) => {
      const description = this.normalizeAiText(item?.description);
      const name = this.normalizeAiText(item?.name);
      return (
        (description &&
          (description.includes(wanted) || wanted.includes(description))) ||
        (name && (name.includes(wanted) || wanted.includes(name)))
      );
    });
    if (partial?.id) return Number(partial.id);

    return undefined;
  }

  private normalizeAiText(value: any): string {
    return String(value ?? "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[.,/\\-]/g, " ")
      .replace(/\s+/g, " ")
      .toLowerCase()
      .trim();
  }

  private highlightAiFields(controlNames: string[]) {
    if (!this.formElementRef?.nativeElement) return;

    for (const name of controlNames) {
      const el = this.formElementRef.nativeElement.querySelector(
        `[formcontrolname="${name}"]`,
      );
      if (!el) continue;
      this.renderer.addClass(el, "ai-field-fill");
      setTimeout(() => this.renderer.removeClass(el, "ai-field-fill"), 1600);
    }
  }

  getSuffix() {
    return this.currencies.find(
      (c: any) => c?.id === this.propertyDetailsForm.get("currency")?.value,
    )?.symbol;
  }

  /**
   * Form Validation
   */
  initFormValidation() {
    const referenceValidators = !this.dataToFormInitDetails?.checkAutoRef
      ? [Validators.required, this.ValidateReference]
      : null;

    if (!this.property && !this.detailsForm?.data?.paymentsConditions) {
      this.paymentsConditions = [
        {
          type: "SALE_AGREEMENT",
          valueType: "PERCENTAGE",
          value: "50",
          paymentMoment: "CPCV",
          agencyValue: "50",
          order: 1,
        },
        {
          type: "DEED",
          valueType: "PERCENTAGE",
          value: "50",
          paymentMoment: "Escritura",
          agencyValue: "50",
          order: 2,
        },
      ];
    } else {
      this.paymentsConditions = this.detailsForm?.data?.paymentsConditions;
    }

    const isAgent = ["AGENT", "COMMERCIAL DIRECTOR"].includes(this.permissionsService?.currentRole || "");
    // Consultores só mudam o estado quando o perfil tem o scope
    // PROPERTY_CHANGE_BUSINESS_STATUS (linha em entity_data_scopes).
    const agentStatusLocked = isAgent && !this.hasChangeBusinessStatusScope();

    if (agentStatusLocked) this.canChangeBusinessStatus = false;

    const warn = (ruleKey: string, control: (c: AbstractControl) => boolean) =>
      this.propertyValidationService.warningIfEnabled(ruleKey, control);

    const validate = (arr: any[]) =>
      arr?.find((p: any) => p.description === "---")?.id;

    const propertyTypeValidate = validate(this.propertyTypes);
    const businessTypeValidate = validate(this.businessTypes);
    const businessStatusValidate = validate(this.businessStatus);
    const conditionValidate = validate(this.conditions);
    const ecValidate = validate(this.ec);
    const getEcKeyById = (ecId: any) =>
      this.ec?.find((e: any) => e.id === ecId)?.key;
    const isEcNumberOptional = (ecKey?: string) =>
      ["Exempted", "Unavailable", "In evaluation"].includes(ecKey ?? "");

    this.propertyDetailsForm = this.formBuilder.group({
      reference: [this.detailsForm?.data?.reference, referenceValidators],

      exclusive: [
        this.detailsForm?.data?.exclusive
          ? this.detailsForm?.data?.exclusive
          : false,
      ],

      store: [
        this.detailsForm?.data?.store
          ? this.detailsForm?.data?.store
          : this.selectDefaultStore.id,
        [Validators.required],
      ],

      propertyType: [
        this.detailsForm?.data?.propertyType
          ? this.detailsForm?.data?.propertyType
          : propertyTypeValidate,
        [
          Validators.required,
          warn(
            "details.propertyType",
            (c) => !!propertyTypeValidate && c?.value === propertyTypeValidate,
          ),
        ],
      ],

      condition: [
        this.detailsForm?.data?.condition
          ? this.detailsForm?.data?.condition
          : conditionValidate,
        [
          Validators.required,
          warn(
            "details.condition",
            (c) => !!conditionValidate && c?.value === conditionValidate,
          ),
        ],
      ],

      businessStatus: [
        this.detailsForm?.data?.businessStatus
          ? this.detailsForm?.data?.businessStatus
          : isAgent
            ? this.prospectingId
            : businessStatusValidate,
        [
          Validators.required,
          warn(
            "details.businessStatus",
            (c) =>
              !!businessStatusValidate && c?.value === businessStatusValidate,
          ),
        ],
      ],

      yearOfConstruction: [this.detailsForm?.data?.yearOfConstruction],

      ec: [
        this.detailsForm?.data?.ec ? this.detailsForm?.data?.ec : ecValidate,
        [
          Validators.required,
          warn("details.ec", (c) => !!ecValidate && c?.value === ecValidate),
        ],
      ],

      ecNumber: [
        this.detailsForm?.data?.ecNumber,
        [
          warn("details.ecNumber", (c) => {
            const ecId =
              c?.parent?.get("ec")?.value ?? this.detailsForm?.data?.ec;
            const ecKey = getEcKeyById(ecId);
            const hasEcNumber = !!String(c?.value ?? "").trim();

            return !hasEcNumber && !isEcNumberOptional(ecKey);
          }),
        ],
      ],

      ecExpirationDate: [this.detailsForm?.data?.ecExpirationDate],

      businessType: [
        this.detailsForm?.data?.businessType
          ? this.detailsForm?.data?.businessType
          : businessTypeValidate,
        [
          Validators.required,
          warn(
            "details.businessType",
            (c) => !!businessTypeValidate && c?.value === businessTypeValidate,
          ),
        ],
      ],

      price: [
        this.detailsForm?.data?.price,
        [warn("details.price", (c) => !c?.value)],
      ],

      rentalPrice: [
        this.detailsForm?.data?.rentalPrice
      ],

      propertyValue: [this.detailsForm?.data?.propertyValue],
      saleDate: [this.detailsForm?.data?.saleDate],
      dealId: [this.detailsForm?.data?.dealId ?? null],
      type: [this.type],

      nproperty: [
        this.detailsForm?.data?.nproperty
          ? this.detailsForm?.data?.nproperty
          : 0,
      ],

      associatedProperty: [this.detailsForm?.data?.associatedProperty],

      propertyType2: [this.detailsForm?.data?.propertyType2],

      legislation: [this.detailsForm?.data?.legislation],
      useLicense: [this.detailsForm?.data?.useLicense],
      buildingLicense: [this.detailsForm?.data?.buildingLicense],
      dateLicense: [this.detailsForm?.data?.dateLicense],
      technicalSheetLicense: [this.detailsForm?.data?.technicalSheetLicense],

      hidePrice: [this.detailsForm?.data?.hidePrice === true],
      hidePriceValue: [this.detailsForm?.data?.hidePriceValue === true],
      hideECNumber: [this.detailsForm?.data?.hideECNumber === true],
      hideECExpirationDate: [
        this.detailsForm?.data?.disableShowECExpirationDate === true,
      ],
      hideUseLicense: [this.detailsForm?.data?.hideECExpirationDate === true],
      hideDateLicense: [this.detailsForm?.data?.hideDateLicense === true],
      hideTechnicalSheetLicense: [
        this.detailsForm?.data?.hideTechnicalSheetLicense === true,
      ],
      hideBuildingLicense: [
        this.detailsForm?.data?.hideBuildingLicense === true,
      ],
      hideExclusive: [this.detailsForm?.data?.hideExclusive === true],

      inventoryValue: [this.detailsForm?.data?.inventoryValue],
      saleValue: [this.detailsForm?.data?.saleValue],

      saleCommission: [
        this.detailsForm?.data?.saleCommission
          ? this.detailsForm?.data?.saleCommission
          : this.dataToFormInitDetails?.commissions?.saleCommission,
      ],

      isPercentageCommission: [
        this.detailsForm?.data?.isPercentageCommission === undefined
          ? true
          : this.detailsForm?.data?.isPercentageCommission === true,
      ],

      isPercentageIncentive: [
        this.detailsForm?.data?.isPercentageIncentive === undefined
          ? true
          : this.detailsForm?.data?.isPercentageIncentive === true,
      ],

      sharedSale: [this.detailsForm?.data?.sharedSale],
      // Partilha interna: repõe tipo, loja parceira e consultor vendedor
      shareType: [
        this.detailsForm?.data?.shareType ??
          (this.detailsForm?.data?.partnerStoreId ? "internal" : "external"),
      ],
      partnerStoreId: [this.detailsForm?.data?.partnerStoreId ?? null],
      internalShareSellerId: [
        this.detailsForm?.data?.internalShareSellerId ?? null,
      ],
      internalShareSellerCommission: [
        this.detailsForm?.data?.internalShareSellerCommission ?? null,
      ],
      incentiveStay: [this.detailsForm?.data?.incentiveStay],

      sharedCommission: [
        this.detailsForm?.data?.sharedCommission
          ? this.detailsForm?.data?.sharedCommission
          : 50,
      ],

      partnerEntityName: [this.detailsForm?.data?.partnerEntityName],

      renewableEnergy: [this.detailsForm?.data?.renewableEnergy],
      carbonEmissions: [this.detailsForm?.data?.carbonEmissions],

      hideCarbonEmissions: [
        this.detailsForm?.data?.hideCarbonEmissions === true,
      ],
      hideRenewableEnergy: [
        this.detailsForm?.data?.hideRenewableEnergy === true,
      ],

      methodPaymentCommission: [
        this.detailsForm?.data?.methodPaymentCommission
          ? this.detailsForm?.data?.methodPaymentCommission
          : 0,
      ],

      splitCommissionValue: [
        this.detailsForm?.data?.splitCommissionValue
          ? this.detailsForm?.data?.splitCommissionValue
          : this.detailsForm?.data?.saleCommission,
      ],

      currency: [
        this.detailsForm?.data?.currency
          ? this.detailsForm?.data?.currency
          : this.dataToFormInitDetails?.currencies?.find(
              (c: any) => c?.currencyCode === "EUR",
            )?.id,
      ],

      paymentsConditions: [this.paymentsConditions],

      isTempReference: [
        this.detailsForm?.data?.isTempReference
          ? true
          : !this.property &&
              this.dataToFormInitDetails?.entityPreferences
                ?.timeReferenceGeneration === "BEFORE_VALIDATION" &&
              this.permissionsService.isAgent(
                this.permissionsService.currentRole,
              )
            ? true
            : false,
      ],

      keyNumber: [this.detailsForm?.data?.keyNumber],
      keyAddress: [this.detailsForm?.data?.keyAddress],
      hasPlate: [this.detailsForm?.data?.hasPlate === true],
      platePlacementDate: [this.detailsForm?.data?.platePlacementDate],
      plateRemovalDate: [this.detailsForm?.data?.plateRemovalDate],
      internalObservations: [this.detailsForm?.data?.internalObservations],
    });

    this.propertyDetailsForm
      .get("ecNumber")
      ?.updateValueAndValidity({ emitEvent: false });

    if (this.canChangeBusinessStatus === false || agentStatusLocked) {
      this.propertyDetailsForm.controls["businessStatus"].disable();
    }

    if (
      (this.form["businessStatus"]?.value === this.saleId ||
        this.rentIds?.includes(this.form["businessStatus"]?.value)) &&
      this.property?.saleInProgress
    ) {
      this.propertyDetailsForm.controls["businessStatus"].disable();
      this.propertyDetailsForm.controls["businessType"].disable();
    }

    this.syncBusinessStatusPermissionLock();
  }

  ValidateReference = (
    control: AbstractControl,
  ): { [key: string]: any } | null => {
    if (this.property) {
      if (
        control?.value &&
        !this.isRefValid &&
        this.property?.reference !== control?.value
      ) {
        return { warning: true };
      }
    } else if (control?.value && !this.isRefValid) {
      return { warning: true };
    }
    return null;
  };

  private validatePropertyType2(): ValidatorFn {
    return this.propertyValidationService.warningIfEnabled(
      "details.propertyType2",
      (control: AbstractControl) => {
        const p = this.propertyTypes2?.find((x: any) => x.id == control?.value);
        return !!p && p.description === "---";
      },
    );
  }

  /**
   * Form data get
   */
  get form() {
    return this.propertyDetailsForm.controls;
  }

  private parseNumericValue(value: any): number {
    if (value === undefined || value === null || value === "") {
      return 0;
    }

    const parsed = Number(
      `${value}`.replace(/\s/g, "").replace(",", ".").replace("%", ""),
    );
    return Number.isFinite(parsed) ? parsed : 0;
  }

  private isPercentageCommissionValue(value: any): boolean {
    return value === true || `${value}`.toLowerCase() === "true";
  }

  private getCommissionPercentForMinimumRule(): number {
    const commission = this.parseNumericValue(
      this.form?.["saleCommission"]?.value,
    );

    if (
      this.isPercentageCommissionValue(
        this.form?.["isPercentageCommission"]?.value,
      )
    ) {
      return commission;
    }

    const saleValue = this.parseNumericValue(this.form?.["saleValue"]?.value);
    const price = this.parseNumericValue(this.form?.["price"]?.value);
    const propertyPrice = saleValue > 0 ? saleValue : price;

    if (propertyPrice <= 0) {
      return 0;
    }

    return (commission / propertyPrice) * 100;
  }

  private get isBelowMinimumCommission(): boolean {
    if (!this.minimumCommissionValidation?.active) {
      return false;
    }

    if (Number(this.form?.["businessType"]?.value) === Number(this.typeRent)) {
      return false;
    }

    if (this.detailsForm?.data?.minimumCommissionApproved === true) {
      return false;
    }

    const minimum = this.minimumCommissionValidation.minimum;
    if (minimum === null || minimum === undefined) {
      return true;
    }

    const commission = this.getCommissionPercentForMinimumRule();
    return commission < minimum;
  }

  get showMinimumCommissionBlockWarning(): boolean {
    return (
      this.minimumCommissionValidation?.action === "BLOCK_SAVE" &&
      this.isBelowMinimumCommission
    );
  }

  get showMinimumCommissionValidationInfo(): boolean {
    return (
      this.minimumCommissionValidation?.action ===
        "SEND_TO_MASTER_VALIDATION" && this.isBelowMinimumCommission
    );
  }

  get minimumCommissionLabel(): string {
    const minimum = this.minimumCommissionValidation?.minimum;
    if (minimum === null || minimum === undefined) {
      return "";
    }

    return `${minimum}%`;
  }

  businessChange() {
    if (
      this.form["businessStatus"].value != this.saleId &&
      !this.rentIds.includes(this.form["businessStatus"].value)
    ) {
      this.form["saleDate"].setValue(null);
    } else {
      if (
        this.form["businessStatus"].value === this.saleId &&
        this.securityForm?.businessStatus !== this.saleId
      ) {
        this.openModal(this.content);
      } else if (
        this.rentIds.includes(this.form["businessStatus"].value) &&
        !this.rentIds.includes(this.securityForm?.businessStatus)
      ) {
        this.openModal(this.contentRent);
      }
    }
  }

  getFormErrors(): [] {
    let errors: any = [];
    Object.keys(this.propertyDetailsForm.controls).forEach((key) => {
      // Get errors of every form control
      let type = this.propertyDetailsForm?.get(key)?.errors;
      if (type) errors.push({ key, type });
    });
    return errors;
  }

  saveDetails() {}

  onChangeStore(event: any) {
    if (this.subscriptionUpdateSore) {
      this.subscriptionUpdateSore.unsubscribe();
    }

    const storeId = this.propertyDetailsForm.get("store")?.value || undefined;

    const updateAgents = () => {
      this.propertiesService.getDataForAgents(storeId).subscribe({
        next: (value) => {
          this.eventService.broadcast("store-data-to-form-init-agents", value);
        },
        error: (err) => console.error(err),
      });

      this.subscriptionUpdateSore = this.eventService.subscribe(
        "set-store-data-to-form-init-agents",
        (data2: any) => {
          this.propertyAgentsData = data2.propertyAgentsData;

          // Só gera preview se autoRef = true
          if (
            this.dataToFormInitDetails.checkAutoRef &&
            !this.isUpdate &&
            !this.propertyDetailsForm.get("isTempReference")?.value
          ) {
            const propertyTypeId =
              this.propertyDetailsForm.get("propertyType")?.value;

            const agentId = this.propertyAgentsData?.find(
              (agent: any) => agent.isMain,
            )?.id;

            if (storeId && propertyTypeId) {
              this.propertiesService
                .previewReference(false, storeId, agentId, propertyTypeId)
                .subscribe({
                  next: (data) => {
                    this.propertyDetailsForm.patchValue(
                      {
                        reference: data.reference,
                      },
                      { emitEvent: false },
                    );
                  },
                  error: () => {
                    this.propertyDetailsForm.patchValue({ reference: "" });
                  },
                });
            }

            return;
          }

          this.eventService.broadcast("get-data-tab-details");

          if (this.storeChangeResult?.isDenied) {
            this.eventService.broadcast("change-tab-add-property", 7);
          }
        },
      );

      this.subscription.add(this.subscriptionUpdateSore);
      this.oldStore = this.propertyDetailsForm.get("store")?.value;
    };

    if (this.propertyAgentsData.length > 0) {
      Swal.fire({
        title: this.translate.instant(
          "t-are-you-sure-you-want-to-change-agency",
        ),
        text: this.translate.instant(
          "t-this-change-may-remove-some-or-all-of-the-agents-that-are-associated-with-this-property",
        ),
        icon: "warning",
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: this.translate.instant(
          "t-change-and-stay-in-the-details",
        ),
        denyButtonText: this.translate.instant("t-change-and-go-to-agents"),
        cancelButtonText: this.translate.instant("t-cancel"),
        customClass: {
          popup: "w-auto",
          confirmButton: "text-white btn bg-primary",
          denyButton: "text-white btn bg-info",
          cancelButton: "text-body btn bg-soft-dark",
          htmlContainer: "w-75 m-auto mt-2",
          title: "pt-2",
        },
      }).then((result) => {
        this.storeChangeResult = result;
        if (result.isConfirmed || result.isDenied) {
          updateAgents();
        } else {
          this.propertyDetailsForm.get("store")?.setValue(this.oldStore);
        }
      });
    } else {
      updateAgents();
    }
    // this.eventService.broadcast("store-changed", storeId);
  }

  onChangePropertyType(event: any) {
    this.propertyDetailsForm.patchValue({ nproperty: 0 });

    const propertyType = this.propertyTypes.find(
      (p: any) => p.id === event?.id,
    );
    this.type = propertyType?.type;
    this.isNproperty = true;

    if (propertyType?.type === 2) {
      this.propertyDetailsForm.get("associatedProperty")?.reset();
      this.propertyTypes2 = this.propertyTypes.filter(
        (pt: any) => pt.type !== 1 && pt.type !== 2 && pt.type !== 3,
      );

      this.propertyDetailsForm
        .get("propertyType2")
        ?.setValidators([Validators.required, this.validatePropertyType2()]);

      this.propertyDetailsForm.get("propertyType2")?.updateValueAndValidity();

      const propertyType2 = this.propertyTypes2?.find(
        (s: any) => s.description === "---",
      );

      if (propertyType2) {
        this.propertyDetailsForm.patchValue({
          propertyType2: propertyType2.id,
        });
      }

      this.propertyDetailsForm
        .get("associatedProperty")
        ?.setValidators([Validators.required]);
      this.propertyDetailsForm
        .get("associatedProperty")
        ?.updateValueAndValidity();

      if (this.propertyDetailsForm.get("store")?.value) {
        const sub = this.propertiesService
          .getDevelopmentsByStore(this.propertyDetailsForm.get("store")?.value)
          .subscribe({
            next: (data) => {
              this.properties = data;
              if (this.properties.length > 0)
                this.propertyDetailsForm.patchValue({
                  associatedProperty: this.properties[0].id,
                });
            },
            error: () => (this.properties = []),
          });
        this.subscription.add(sub);
      }
    } else if (propertyType?.type === 3) {
      this.propertyDetailsForm.get("associatedProperty")?.reset();
      if (propertyType) {
        this.propertyTypes2 = this.propertyTypes.filter(
          (pt: any) =>
            (pt.groupId === propertyType.groupId && pt.type !== 3) ||
            pt.type === 4,
        );
      } else this.propertyTypes2 = undefined;

      this.propertyDetailsForm
        .get("propertyType2")
        ?.setValidators([Validators.required, this.validatePropertyType2()]);
      this.propertyDetailsForm.get("propertyType2")?.updateValueAndValidity();
      const propertyType2 = this.propertyTypes2?.find(
        (s: any) => s.description === "---",
      );
      if (propertyType2) {
        this.propertyDetailsForm.patchValue({
          propertyType2: propertyType2.id,
        });
      }

      this.propertyDetailsForm
        .get("associatedProperty")
        ?.setValidators([Validators.required]);
      this.propertyDetailsForm
        .get("associatedProperty")
        ?.updateValueAndValidity();

      if (
        this.propertyDetailsForm.get("store")?.value &&
        this.propertyDetailsForm.get("propertyType")?.value
      ) {
        const sub = this.propertiesService
          .getPropertiesByStoreAndPropertyType(
            this.propertyDetailsForm.get("store")?.value,
            this.propertyDetailsForm.get("propertyType")?.value,
          )
          .subscribe({
            next: (data) => {
              this.properties = data;
              if (this.properties.length > 0)
                this.propertyDetailsForm.patchValue({
                  associatedProperty: this.properties[0].id,
                });
            },
            error: () => (this.properties = []),
          });
        this.subscription.add(sub);
      }
    } else {
      this.properties = [];
      this.propertyDetailsForm.get("propertyType2")?.setValidators(null);
      this.propertyDetailsForm.get("propertyType2")?.updateValueAndValidity();
      this.propertyDetailsForm.get("associatedProperty")?.setValidators(null);
      this.propertyDetailsForm
        .get("associatedProperty")
        ?.updateValueAndValidity();
      this.propertyDetailsForm.get("propertyType2")?.reset();
      this.propertyDetailsForm.get("associatedProperty")?.reset();
    }

    const storeId = this.propertyDetailsForm.get("store")?.value;
    const agentId = this.propertyAgentsData?.find((ag: any) => ag.isMain)?.id;
    const propertyTypeId = this.propertyDetailsForm.get("propertyType")?.value;

    if (
      this.dataToFormInitDetails?.checkAutoRef &&
      !this.isUpdate &&
      !this.propertyDetailsForm.get("isTempReference")?.value
    ) {
      if (storeId && propertyTypeId) {
        this.propertiesService
          .previewReference(false, storeId, agentId, propertyTypeId)
          .subscribe({
            next: (data) => {
              this.propertyDetailsForm.patchValue(
                {
                  reference: data.reference,
                },
                { emitEvent: false },
              );
            },
            error: () => {
              this.propertyDetailsForm.patchValue({ reference: "" });
            },
          });
      }

      return;
    }

    setTimeout(() => {
      this.eventService.broadcast("get-data-tab-details");
      this.eventService.broadcast("property-type-changed");
    });
  }

  onChangeUnitNumber(event: any) {
    if (this.type !== 2 && this.type !== 3)
      if (event > 0 && this.isNproperty) {
        this.isNproperty = false;
        if (this.type === 1) {
          this.propertyTypes2 = this.propertyTypes.filter(
            (pt: any) => pt.type !== 1 && pt.type !== 2 && pt.type !== 3,
          );
          this.propertyDetailsForm
            .get("propertyType2")
            ?.setValidators([
              Validators.required,
              this.validatePropertyType2(),
            ]);
        } else if (this.type === 4) {
          this.propertyTypes2 = undefined;
          this.propertyDetailsForm.get("propertyType2")?.setValidators(null);
          this.propertyDetailsForm
            .get("propertyType2")
            ?.updateValueAndValidity();
        } else if (this.type === 0) {
          //buscar tipo
          const propertyType = this.propertyTypes.find(
            (p: any) =>
              p.id === this.propertyDetailsForm.get("propertyType")?.value,
          );
          if (propertyType)
            this.propertyTypes2 = this.propertyTypes.filter(
              (pt: any) =>
                (pt.groupId === propertyType.groupId && pt.type !== 3) ||
                pt.type === 4,
            );
          else this.propertyTypes2 = undefined;

          this.propertyDetailsForm
            .get("propertyType2")
            ?.setValidators([
              Validators.required,
              this.validatePropertyType2(),
            ]);
          this.propertyDetailsForm
            .get("propertyType2")
            ?.updateValueAndValidity();
        }
        let propertyType2 = this.propertyTypes2?.find(
          (s: any) =>
            s.id === this.propertyDetailsForm.get("propertyType2")?.value,
        );
        if (!propertyType2)
          propertyType2 = this.propertyTypes2?.find(
            (s: any) => s.description === "---",
          );
        if (propertyType2) {
          this.propertyDetailsForm.patchValue({
            propertyType2: propertyType2.id,
          });
        }
      } else if (event === 0) {
        this.propertyDetailsForm.get("propertyType2")?.setValidators(null);
        this.propertyTypes2 = undefined;
        this.isNproperty = true;
      }
  }

  onChangeYearBuilding(year: any) {
    if (year > 1951) {
      //1952-01-25
      // mostra campo licença
    } else {
    }
  }

  onChangeEC(ec1: any) {
    const ec = this.ec.find((ec2: any) => ec2.id === ec1.id);
    if (ec?.legislations?.length > 0) {
      this.legislations = ec.legislations;
    } else {
      this.propertyDetailsForm.patchValue({ legislation: null });
      this.legislations = undefined;
    }
  }

  openModal(content: any) {
    this.modalService.open(content, {
      size: "xl",
      centered: true,
      backdropClass: "custom-modal",
      scrollable: true,
    });
  }

  private openSaleDetailsModal(): void {
    const businessStatus = Number(this.form["businessStatus"]?.value);

    if (businessStatus === Number(this.saleId)) {
      this.openModal(this.content);
      return;
    }

    if (this.rentIds?.includes(this.form["businessStatus"]?.value)) {
      this.openModal(this.contentRent);
    }
  }

  private loadEntitySettings() {
    this.entityService.getEntityForProposal().subscribe({
      next: (entity) => {
        this.requiredDealForSale = entity?.requiredDealForSale ?? false;
        this.requiredSellerForSale = entity?.requiredSellerForSale ?? false;
        this.ensureDealValidationForSale();
      },
    });
  }

  private ensureDealValidationForSale(): boolean {
    const dealControl = this.propertyDetailsForm?.get("dealId");
    if (!dealControl) {
      return true;
    }

    const currentStatus = Number(this.form["businessStatus"]?.value);
    const requiresDeal =
      this.requiredDealForSale &&
      (currentStatus === Number(this.saleId) ||
        this.rentIds?.includes(currentStatus));

    if (requiresDeal) {
      dealControl.setValidators([Validators.required]);
      dealControl.updateValueAndValidity({ emitEvent: false });
      if (!dealControl.value) {
        dealControl.markAsTouched();
        return false;
      }
      return true;
    }

    dealControl.clearValidators();
    dealControl.updateValueAndValidity({ emitEvent: false });
    return true;
  }

  private ensureSellerValidationForSale(): boolean {
    const currentStatus = Number(this.form["businessStatus"]?.value);
    const isSaleOrRentStatus = this.isSaleOrRentBusinessStatus(currentStatus);
    const wasSaleOrRentStatus = this.property
      ? this.isCurrentPropertySaleOrRentStatus()
      : false;
    const isSharedSale = this.form["sharedSale"]?.value === true;
    const hasSeller = this.getAgents("selling")?.length > 0;
    const requiresSeller =
      this.requiredSellerForSale &&
      isSaleOrRentStatus &&
      !wasSaleOrRentStatus &&
      !this.property?.saleInProgress &&
      !isSharedSale;

    if (!requiresSeller || hasSeller) {
      this.clearSellerRequiredError();
      return true;
    }

    this.propertyDetailsForm.setErrors({
      ...(this.propertyDetailsForm.errors ?? {}),
      sellerRequired: true,
    });

    return false;
  }

  private clearSellerRequiredError(): void {
    const errors = this.propertyDetailsForm.errors;
    if (!errors?.["sellerRequired"]) {
      this.sellerRequiredWarningShown = false;
      return;
    }

    const remainingErrors = { ...errors };
    delete remainingErrors["sellerRequired"];
    this.propertyDetailsForm.setErrors(
      Object.keys(remainingErrors).length ? remainingErrors : null,
    );
    this.sellerRequiredWarningShown = false;
  }

  tryCloseSaleDetailsModal(modal: any): void {
    if (!this.ensureSellerValidationForSale()) {
      this.showSellerRequiredWarning();
      return;
    }

    modal.dismiss();
  }

  private showSellerRequiredWarning(): void {
    if (this.sellerRequiredWarningShown) {
      return;
    }

    this.sellerRequiredWarningShown = true;
    Swal.fire({
      icon: "warning",
      title: this.translate.instant("t-sale-seller-required"),
      confirmButtonColor: "rgb(54, 69, 116)",
      confirmButtonText: this.translate.instant("t-close"),
    }).finally(() => {
      this.sellerRequiredWarningShown = false;
    });
  }

  setEletemtConfig() {
    this.securityForm = this.propertyDetailsForm.value;
    // if (!this.permissionsService.checkMasterPermission('EDIT_PROPERTY_DETAILS', this.property?.store?.id) && !this.permissionsService.checkPropertyAgentPermission(this.property, 'EDIT_PROPERTY_DETAILS') && this.property) {
    //   this.securityForm = this.propertyDetailsForm.value;
    // }

    if (
      !this.permissionsService.checkMasterPermission(
        "EDIT_PROPERTY_DETAILS",
        this.property?.store?.id,
      ) &&
      !this.permissionsService.checkPropertyAgentPermission(
        this.property,
        "EDIT_PROPERTY_DETAILS",
      ) &&
      this.property
    ) {
      if (this.formElementRef.nativeElement) {
        this.renderer.setStyle(
          this.formElementRef.nativeElement,
          "pointer-events",
          "none",
        );
        const parentElement = this.formElementRef.nativeElement.parentElement;

        if (parentElement) {
          this.renderer.setStyle(parentElement, "cursor", "not-allowed");
          const warning = parentElement.querySelectorAll(".is-warning");
          if (warning) {
            warning?.forEach((el: any) => {
              this.renderer.removeClass(el, "is-warning");
            });
          }
        }
      }
    }
  }

  /**
   * Checa referência: unicidade e gera preview (automático)
   */
  checkReference(isOfficialReference: boolean = false) {
    const refCtrl = this.propertyDetailsForm.get("reference");
    this.ref = (refCtrl?.value ?? "").trim();

    const storeId = this.propertyDetailsForm.get("store")?.value || undefined;
    const propertyTypeId =
      this.propertyDetailsForm.get("propertyType")?.value || undefined;
    const agMain =
      this.propertyAgentsData?.find((agent: any) => agent.isMain) || undefined;
    const agentId = agMain?.id;

    // 🔹 Se autoRef = true → gera preview e substitui this.ref
    if (this.dataToFormInitDetails?.checkAutoRef && !this.isUpdate) {
      if (!this.ref) {
        const loader = document.querySelector(".propertyLoader2");
        this.renderer.removeClass(loader, "d-none");

        this.propertiesService
          .previewReference(
            this.permissionsService.isAgent(
              this.permissionsService.userAuth.role?.name,
            ) &&
              this.dataToFormInitDetails?.entityPreferences
                ?.timeReferenceGeneration === "BEFORE_VALIDATION" &&
              !isOfficialReference,
            Number.isFinite(+storeId) ? +storeId : undefined,
            agentId ?? undefined,
            Number.isFinite(+propertyTypeId) ? +propertyTypeId : undefined,
          )
          .subscribe({
            next: ({ reference }) => {
              if (reference) {
                this.ref = reference.toUpperCase();
                refCtrl?.patchValue(this.ref);
                this.detailsForm.data.reference = this.ref;

                // bloqueia input visualmente
                setTimeout(() => {
                  if (this.dataToFormInitDetails?.checkAutoRef) {
                    this.myInputs.forEach((input: ElementRef) => {
                      if (input.nativeElement.id === "refereceInput") {
                        this.renderer.setStyle(
                          input.nativeElement,
                          "pointer-events",
                          "none",
                        );
                        this.renderer.addClass(
                          input.nativeElement,
                          "text-black-50",
                        );

                        const parent = input.nativeElement.parentElement;
                        if (parent)
                          this.renderer.setStyle(
                            parent,
                            "cursor",
                            "not-allowed",
                          );

                        const label = parent?.querySelector("label");
                        if (label)
                          this.renderer.setStyle(
                            label,
                            "cursor",
                            "not-allowed",
                          );
                      }
                    });
                  }
                });
              }
              this.renderer.addClass(loader, "d-none");
            },
            error: () => {
              this.isRefValid = false;
              this.renderer.addClass(loader, "d-none");
            },
          });
      } else {
        this.validateUniqueReference(refCtrl);
      }

      return;
    }

    // 🔹 Se autoRef = false → apenas valida unicidade do que foi digitado
    if (
      this.ref &&
      this.property?.reference !== this.ref &&
      !this.dataToFormInitDetails.checkAutoRef
    ) {
      this.validateUniqueReference(refCtrl);
    }
  }

  private validateUniqueReference(refCtrl: AbstractControl | null) {
    this.propertiesService.checkReference(this.ref).subscribe({
      next: ({ unique }) => {
        this.isRefValid = unique;

        if (!unique) {
          refCtrl?.addValidators(this.ValidateReference);
          refCtrl?.updateValueAndValidity();
        }
      },
      error: () => (this.isRefValid = false),
    });
  }

  showAlertSuccess(msg: string) {
    Swal.fire({
      icon: "warning",
      title: msg,
      validationMessage: this.translate.instant(
        "t-property-validation-message",
      ),
      showConfirmButton: false,
      timer: 1500,
    });
  }

  getTabDetails() {
    this.ensureDealValidationForSale();
    const hasRequiredSeller = this.ensureSellerValidationForSale();

    const statusDisabled =
      this.propertyDetailsForm.controls["businessStatus"].disabled;

    if (statusDisabled) {
      this.propertyDetailsForm.controls["businessStatus"].enable();
    }

    const typeDisabled =
      this.propertyDetailsForm.controls["businessType"].disabled;

    if (typeDisabled) {
      this.propertyDetailsForm.controls["businessType"].enable();
    }

    if (
      this.form["businessStatus"]?.value === this.saleId ||
      this.rentIds.includes(this.form["businessStatus"]?.value)
    ) {
      if (
        this.form["price"]?.value &&
        (!this.form["saleValue"].value || this.form["saleValue"].value == 0)
      ) {
        this.propertyDetailsForm.controls["saleValue"].setValue(
          Number(this.form["price"].value),
        );
      }

      if (!this.form["saleDate"].value) {
        this.propertyDetailsForm.controls["saleDate"].setValue(new Date());
      }
    }

    if (
      !this.permissionsService.checkMasterPermission(
        "EDIT_PROPERTY_DETAILS",
        this.property?.store?.id,
      ) &&
      !this.permissionsService.checkPropertyAgentPermission(
        this.property,
        "EDIT_PROPERTY_DETAILS",
      ) &&
      this.property
    ) {
      this.propertyDetailsForm.setValue(this.securityForm);
    }
    this.propertyDetailsForm.patchValue({
      paymentsConditions: this.paymentsConditions,
    });

    this.detailsForm.data = this.propertyDetailsForm.value;
    this.detailsForm.errors = this.getFormErrors();
    if (!hasRequiredSeller) {
      this.detailsForm.errors.push({
        key: "seller",
        type: { sellerRequired: true },
      });
    }
    this.detailsForm.valid = this.propertyDetailsForm.valid;

    if (statusDisabled) {
      this.propertyDetailsForm.controls["businessStatus"].disable();
    }

    if (typeDisabled) {
      this.propertyDetailsForm.controls["businessType"].disable();
    }
    this.cdr.detectChanges();
    this.eventService.broadcast("check-warning-add-property");
  }

  priceFormat(propertyPrice: any, symbol: string = "€") {
    if (propertyPrice) {
      let price = propertyPrice.toString().split(".");
      const spaces = (price: any) =>
        String(price).replace(/(?!^)(?=(?:\d{3})+$)/g, " ");
      const price1 = spaces(price[0]);
      if (price.length > 1) return price1 + "," + price[1] + " " + symbol;

      return price1 + " " + symbol;
    }
    return propertyPrice;
  }

  getAgents(type: "listing" | "selling") {
    if (type === "listing")
      return this.propertyAgentsData?.filter((a: any) => a.isListingAgent);

    return this.propertyAgentsData?.filter((a: any) => a.isSellingAgent);
  }

  getStoreById(id: any) {
    return this.stores?.find((s: any) => s.id === id)?.name || "";
  }

  addAgent(type: "listing" | "selling") {
    this.selected[type] = null;
    this.openNewAgent[type] = true;
  }

  removeAgent(type: "listing" | "selling", id: any) {
    const agent = this.allAgents?.find((a: any) => a.id === id);
    if (agent) {
      if (type === "listing") {
        agent.isListingAgent = false;
        const find = this.propertyAgentsData.find(
          (ag: any) => ag.id == agent.id,
        );
        if (find) {
          find.isListingAgent = false;
        }
      } else {
        agent.isSellingAgent = false;
        const find = this.propertyAgentsData.find(
          (ag: any) => ag.id == agent.id,
        );
        if (find) {
          find.isSellingAgent = false;
        }
      }

      this.refreshListings();
    }
  }

  onChangeAgent(id: any, type: "listing" | "selling") {
    if (id) {
      const agentData = this.allAgents?.find((a: any) => a.id === id);
      if (type === "listing" && this.isStoreOperatorAgent(agentData)) {
        return;
      }

      if (!this.propertyAgentsData.find((ag: any) => ag.id == id)) {
        this.propertyAgentsData.push(agentData);
      }
      const agent = this.propertyAgentsData?.find((a: any) => a.id === id);
      if (agent) {
        if (type === "listing" && this.isStoreOperatorAgent(agent)) {
          return;
        }
        agent.add = true;
        if (type === "listing") {
          const newCommission = this.getNewCommission("listing");
          agent.isListingAgent = true;
          this.propertyAgentsData = this.propertyAgentsData.map((a: any) => {
            if (a.isListingAgent) {
              return {
                ...a,
                listingCommission:
                  newCommission && Number(newCommission) > 0
                    ? Number(newCommission)
                    : a.listingCommission,
              };
            }
            return a;
          });
          this.openNewAgent[type] = false;
          this.refreshListings();
        } else {
          const newCommission = this.getNewCommission("selling");
          agent.isSellingAgent = true;
          this.propertyAgentsData = this.propertyAgentsData.map((a: any) => {
            if (a.isSellingAgent) {
              return {
                ...a,
                saleCommission:
                  newCommission && Number(newCommission) > 0
                    ? Number(newCommission)
                    : a.saleCommission,
              };
            }
            return a;
          });
          this.openNewAgent[type] = false;
          this.refreshListings();
        }
        this.agentsChange.emit(this.propertyAgentsData);
      }
    }
  }

  getNewCommission(type: "listing" | "selling") {
    if (type === "listing") {
      const agentsListing = this.propertyAgentsData?.filter(
        (a: any) => a.isListingAgent,
      );
      const commission = agentsListing?.reduce(
        (acc: number, agent: any) =>
          acc + (Number(agent.listingCommission) || 0),
        0,
      );
      return Number.isInteger(commission / (agentsListing.length + 1))
        ? commission / (agentsListing.length + 1)
        : (commission / (agentsListing.length + 1)).toFixed(2);
    } else {
      const agentsSelling = this.propertyAgentsData?.filter(
        (a: any) => a.isSellingAgent,
      );
      const commission = agentsSelling?.reduce(
        (acc: number, agent: any) => acc + (Number(agent.saleCommission) || 0),
        0,
      );
      return Number.isInteger(commission / (agentsSelling.length + 1))
        ? commission / (agentsSelling.length + 1)
        : (commission / (agentsSelling.length + 1)).toFixed(2);
    }
  }

  refreshListings() {
    this.agentsExceptListing = this.allAgents?.filter(
      (a: any) =>
        !this.isStoreOperatorAgent(a) &&
        !this.propertyAgentsData
          ?.filter((ag: any) => ag.isListingAgent)
          .find((ag: any) => ag.id == a.id),
    );
    this.agentsExceptSelling = this.allAgents?.filter(
      (a: any) =>
        !this.propertyAgentsData
          ?.filter((ag: any) => ag.isSellingAgent)
          .find((ag: any) => ag.id == a.id),
    );
  }

  // Delegado ao PermissionsService: um STORE OPERATOR deixa de ser excluído
  // quando a entidade liga "diretores de loja também atuam como consultores".
  private isStoreOperatorAgent(agent: any): boolean {
    return !this.permissionsService.canBeListingAgent(agent);
  }

  // getValueBusinessStatus(id: number) {
  //   console.log(this.businessStatus);
  //   const findStatus = this.businessStatus.filter((status: any) => status.id === id).map((status: any) => status.description)
  //   return this.formatStatusValueMap[findStatus[0]]
  // }

  contractNumberRef(ref: string) {
    return ref ? ref.replace(/\D+/g, "") : "";
  }

  /**
   * O perfil do consultor tem o scope PROPERTY_CHANGE_BUSINESS_STATUS?
   * Só chega no `dataScopes` do login para AGENT; para as outras roles é
   * sempre `false`. O servidor aplica a mesma regra no update.
   */
  private hasChangeBusinessStatusScope(): boolean {
    return this.permissionsService.hasEntityDataScope(
      "PROPERTY_CHANGE_BUSINESS_STATUS",
    );
  }

  private lacksSellPropertiesPermission(): boolean {
    const storeId = this.getPropertyStoreId();

    return (
      !this.permissionsService.checkMasterPermission(
        "SELL_PROPERTIES",
        storeId,
      ) &&
      !this.permissionsService.checkPropertyAgentPermission(
        this.property,
        "SELL_PROPERTIES",
      )
    );
  }

  private getPropertyStoreId(): any {
    return this.property?.store?.id ?? this.property?.storeId ?? this.property?.store;
  }

  private isSaleOrRentBusinessStatus(statusId: any): boolean {
    const normalizedStatusId = Number(statusId);
    return (
      normalizedStatusId === Number(this.saleId) ||
      (this.rentIds ?? [])
        .map((id: any) => Number(id))
        .includes(normalizedStatusId)
    );
  }

  private isCurrentPropertySaleOrRentStatus(): boolean {
    const currentStatusText = [
      this.property?.propertyBusinessStatus?.description,
      this.property?.propertyBusinessStatus?.code,
      this.property?.details?.businessStatusData?.description,
      this.property?.details?.businessStatusData?.code,
    ]
      .filter(Boolean)
      .map((value: any) => `${value}`.trim().toUpperCase());

    if (
      currentStatusText.some((value: string) =>
        ["SOLD", "RENTED", "LEASED"].includes(value),
      )
    ) {
      return true;
    }

    return this.isSaleOrRentBusinessStatus(
      this.property?.propertyBusinessStatusId ??
        this.property?.propertyBusinessStatus?.id ??
        this.property?.details?.businessStatusData?.id ??
        this.property?.details?.businessStatus ??
        this.securityForm?.businessStatus ??
        this.detailsForm?.data?.businessStatus,
    );
  }

  private syncBusinessStatusPermissionLock(): void {
    if (
      this.propertyDetailsForm &&
      this.isBusinessStatusDisabled() &&
      this.propertyDetailsForm.controls["businessStatus"].enabled
    ) {
      this.propertyDetailsForm.controls["businessStatus"].disable({
        emitEvent: false,
      });
    }
  }

  private resolvePlatePlacementMinDate(): Date | null {
    const roleName =
      this.permissionsService.userAuth?.role?.name ??
      this.permissionsService.currentRole;

    if (this.permissionsService.isRealMaster(roleName)) {
      return null;
    }

    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), 1);
  }

  isBusinessStatusDisabled(): boolean {
    // 1️⃣ Agente criando novo imóvel — sempre "Em prospeção"
    if (
      !this.property &&
      this.permissionsService.isAgent(
        this.permissionsService.userAuth.role?.name,
      )
    ) {
      return true;
    }

    // 2️⃣ Enviado para validação
    if (this.property?.propertyBusinessStatus?.description === "To Validate") {
      return true;
    }

    // 3️⃣ Venda/aluguel em progresso
    if (this.property?.saleInProgress) {
      return true;
    }

    if (
      this.property &&
      this.lacksSellPropertiesPermission() &&
      this.isCurrentPropertySaleOrRentStatus()
    ) {
      return true;
    }

    // 4️⃣ Caso geral — se não tiver permissão de alterar
    if (!this.canChangeBusinessStatus) {
      return true;
    }

    return false;
  }

  isOptionDisabled(item: any): boolean {
    // Bloqueia venda/aluguel se usuário não tiver permissão
    const noSellPermission = this.lacksSellPropertiesPermission();

    if (
      noSellPermission &&
      this.isSaleOrRentBusinessStatus(item.id)
    ) {
      return true;
    }

    // Bloqueia alterações durante venda em progresso
    if (
      this.property?.saleInProgress &&
      item.id !== this.saleId &&
      !this.rentIds.includes(item.id)
    ) {
      return true;
    }

    return false;
  }

  // detalhes financeiro que devem ir para propostas

  /** preço atual (considera venda/reserva com saleValue) */
  private getCurrentPrice(): number {
    const d = this.detailsForm?.data ?? {};
    const status = d.businessStatus;
    if (
      (status === this.saleId || this.rentIds?.includes(status)) &&
      d.saleValue
    ) {
      return Number(d.saleValue) || 0;
    }
    return Number(d.price) || 0;
  }

  /** contexto de comissão/incentivo global do imóvel */
  private getCommissionContext() {
    const d = this.detailsForm?.data ?? {};
    return {
      isPercentageCommission: !!d.isPercentageCommission,
      saleCommission: Number(d.saleCommission) || 0,
      // incentivos podem não existir — default 0
      isPercentageIncentive: !!d.isPercentageIncentive,
      // incentiveStay: Number(d.incentiveStay) || 0,
    };
  }

  onPaymentChange(payment: any) {
    const price = this.getCurrentPrice();

    let totalFixed = 0;
    let totalPercent = 0;

    this.paymentsConditions?.forEach((p) => {
      const value = Number((p.value || "0").toString().replace(/\s/g, ""));
      if (p === payment) return; // ignora o que está editando
      if (p.valueType === "FIXED") totalFixed += value;
      else if (p.valueType === "PERCENTAGE") totalPercent += value;
    });

    const currentValue = Number(
      (payment.value || "0").toString().replace(/\s/g, ""),
    );

    if (price > 0) {
      const used = totalFixed + (totalPercent * price) / 100;

      if (payment.valueType === "FIXED") {
        const maxAllowed = price - used;
        if (currentValue > maxAllowed) {
          const suggestion = maxAllowed;
          if (this.toastService.toasts?.length === 0)
            this.showToast(payment.type, suggestion.toLocaleString(), "€");
        }
      } else if (payment.valueType === "PERCENTAGE") {
        const maxAllowed = ((price - used) / price) * 100;
        if (currentValue > maxAllowed) {
          const suggestion = +maxAllowed.toFixed(2);
          if (this.toastService.toasts?.length === 0)
            this.showToast(payment.type, suggestion, "%");
        }
      }
    } else {
      // sem preço: só valida percentuais
      if (payment.valueType === "PERCENTAGE") {
        const maxAllowed = 100 - totalPercent;
        if (currentValue > maxAllowed) {
          const suggestion = +maxAllowed.toFixed(2);
          if (this.toastService.toasts?.length === 0)
            this.showToast(payment.type, suggestion, "%");
        }
      }
    }
  }

  showToast(text: any, value: any, type: "%" | "€") {
    const typeStr = this.translate.instant(this.getPaymentConditionText(text));
    const fullText = this.translate.instant(
      "t-new-sales.t-total-commission-warning",
      {
        value1: typeStr,
        value2: value,
        value3: type,
      },
    );
    this.toastService.show(`⚠️ ${fullText}`, {
      classname: "bg-warning text-white",
      delay: 4000,
    });
  }

  addPaymentCondition() {
    if (this.paymentsConditions)
      this.paymentsConditions.push({
        type: "SIGNAL",
        valueType: "PERCENTAGE",
        value: "0",
        paymentMoment: "",
        agencyValue: "0",
        order: this.paymentsConditions.length + 1,
      });
    else
      this.paymentsConditions = [
        {
          type: "SALE_AGREEMENT",
          valueType: "PERCENTAGE",
          value: "50",
          paymentMoment: "",
          agencyValue: "50",
          order: 1,
        },
      ];
  }

  removePaymentCondition(index: number) {
    this.paymentsConditions?.splice(index, 1);
    this.reorderPayments();
  }

  drop(event: any) {
    moveItemInArray(
      this.paymentsConditions ?? [],
      event.previousIndex,
      event.currentIndex,
    );
    this.reorderPayments();
  }

  reorderPayments() {
    this.paymentsConditions = this.paymentsConditions?.map((p, i) => ({
      ...p,
      order: i + 1,
    }));
  }

  getPaymentConditionText(
    type: "DEED" | "SALE_AGREEMENT" | "RESERVATION" | "SIGNAL",
  ) {
    switch (type) {
      case "DEED":
        return "t-new-sales.t-deed";
      case "SALE_AGREEMENT":
        return "t-new-sales.t-sale-agreement";
      case "RESERVATION":
        return "t-new-sales.t-reservation";
      case "SIGNAL":
        return "t-new-sales.t-signal";
      default:
        return "";
    }
  }

  getPaymentConditionIcon(
    type: "DEED" | "SALE_AGREEMENT" | "RESERVATION" | "SIGNAL",
  ) {
    switch (type) {
      case "DEED":
        return "mdi-file-document-edit-outline";
      case "SALE_AGREEMENT":
        return "mdi-file-sign";
      case "RESERVATION":
        return "mdi-handshake-outline";
      case "SIGNAL":
        return "mdi-cash-fast";
      default:
        return "";
    }
  }

  getPaymentConditionValue(payment: {
    type: "DEED" | "SALE_AGREEMENT" | "RESERVATION" | "SIGNAL";
    valueType: "PERCENTAGE" | "FIXED";
    value: string;
  }) {
    const price = this.getCurrentPrice();

    if (payment.valueType === "PERCENTAGE") {
      if (price) {
        const percentage = Number(payment.value || 0);
        const val = this.formatNumber(price * (percentage / 100));
        return `${this.priceFormat(val)} (${percentage}%)`;
      } else {
        return `${payment.value} %`;
      }
    } else {
      if (price) {
        const fixedValue = Number(payment.value || 0);
        const pct = this.formatNumber((fixedValue / price) * 100);
        return `${this.priceFormat(payment.value)} (${pct} %)`;
      } else {
        return `${this.priceFormat(payment.value)}`;
      }
    }
  }

  getPaymentConditionAgencyValue(payment: {
    type: "DEED" | "SALE_AGREEMENT" | "RESERVATION" | "SIGNAL";
    valueType: "PERCENTAGE" | "FIXED";
    value: string;
    agencyValue?: string; // % da comissão da agência pago nesta fase (sobre a COMISSÃO)
  }) {
    const price = this.getCurrentPrice();
    const {
      isPercentageCommission,
      saleCommission,
      isPercentageIncentive,
      // incentiveStay,
    } = this.getCommissionContext();

    if (price > 0) {
      // totais globais
      const commissionTotal = isPercentageCommission
        ? price * (saleCommission / 100)
        : saleCommission;
      // const incentiveTotal = isPercentageIncentive
      //   ? price * (incentiveStay / 100)
      //   : incentiveStay;

      const agencyPhasePct = Number(payment.agencyValue) || 0;

      const commissionThisPhase = commissionTotal * (agencyPhasePct / 100);
      // const incentiveThisPhase = incentiveTotal * (agencyPhasePct / 100);

      const valueStr = this.priceFormat(this.formatNumber(commissionThisPhase));
      // const valueIncentive = this.priceFormat(
      //   this.formatNumber(incentiveThisPhase)
      // );
      const pctStr = ` (${this.formatNumber(agencyPhasePct)}%)`;

      // mostra comissão e, se houver, o incentivo também
      // if (incentiveThisPhase > 0) {
      //   return `${valueStr}${pctStr} + ${valueIncentive}${pctStr}`;
      // }
      return `${valueStr}${pctStr}`;
    } else {
      const agencyValue = Number(payment.agencyValue) || 0;
      return `${agencyValue}%`;
    }
  }

  formatNumber(value: number): string {
    return value % 1 === 0 ? value.toString() : value.toFixed(2);
  }

  ngOnDestroy(): void {
    if (this.propertyDetailsForm.controls["businessStatus"].disabled) {
      this.propertyDetailsForm.controls["businessStatus"].enable();
    }
    if (this.propertyDetailsForm.controls["businessType"].disabled) {
      this.propertyDetailsForm.controls["businessType"].enable();
    }
    this.subscriptionSubmitted.unsubscribe();
    this.subscription.unsubscribe();

    if (
      this.form["businessStatus"]?.value === this.saleId ||
      this.rentIds.includes(this.form["businessStatus"]?.value)
    ) {
      if (
        this.form["price"]?.value &&
        (!this.form["saleValue"].value || this.form["saleValue"].value == 0)
      ) {
        this.propertyDetailsForm.controls["saleValue"].setValue(
          Number(this.form["price"].value),
        );
      }
      if (!this.form["saleDate"].value) {
        this.propertyDetailsForm.controls["saleDate"].setValue(new Date());
      }
    }

    if (!this.form["currency"].value) {
      const eur = this.currencies?.find(
        (c: any) => c?.currencyCode === "EUR",
      )?.id;
      this.propertyDetailsForm.controls["currency"].setValue(eur);
    }
    this.propertyDetailsForm.patchValue({
      paymentsConditions: this.paymentsConditions,
    });

    if (
      (!this.property || this.form["isTempReference"].value) &&
      this.dataToFormInitDetails?.entityPreferences?.timeReferenceGeneration ===
        "BEFORE_VALIDATION"
    ) {
      if (this.permissionsService.isAgent(this.permissionsService.currentRole))
        this.propertyDetailsForm.patchValue({
          isTempReference: true,
        });
    } else if (
      this.property &&
      this.form["isTempReference"].value &&
      this.dataToFormInitDetails?.entityPreferences?.timeReferenceGeneration ===
        "BEFORE_VALIDATION"
    ) {
      // Manter isTempReference true se o imóvel já tem referência temporária
      this.propertyDetailsForm.patchValue({
        isTempReference: true,
      });
    } else {
      this.propertyDetailsForm.patchValue({
        isTempReference: false,
      });
    }

    if (
      !this.permissionsService.canEditProperty(
        this.propertiesService.getUserAuth(),
        this.property?.store?.id,
      ) &&
      !this.permissionsService.canEditPropertyWithoutAgent(this.property) &&
      this.property &&
      !this.permissionsService.hasPermission("EDIT_PROPERTY_DETAILS")
    ) {
      this.propertyDetailsForm.setValue(this.securityForm);
    }
    this.detailsForm.data = this.propertyDetailsForm.value;
    this.detailsForm.errors = this.getFormErrors();
    this.detailsForm.valid = this.propertyDetailsForm.valid;
    this.cdr.detectChanges();
    this.eventService.broadcast("check-warning-add-property");

    this.destroy$.next();
    this.destroy$.complete();
    this.aiExtractedSub?.unsubscribe();
  }

  private resolveOptionDescription(
    list: any[] | undefined,
    id: any,
  ): string | undefined {
    if (!Array.isArray(list) || id === null || id === undefined)
      return undefined;
    const item = list.find((entry: any) => Number(entry?.id) === Number(id));
    const description = String(item?.description ?? "").trim();
    return description.length ? description : undefined;
  }

  private buildDetailsForAiContext(raw: any): any {
    const value = raw ?? {};
    const propertyTypeId = value?.propertyType2 || value?.propertyType;
    return {
      ...value,
      propertyTypeDescription: this.resolveOptionDescription(
        this.propertyTypes,
        propertyTypeId,
      ),
      conditionDescription: this.resolveOptionDescription(
        this.conditions,
        value?.condition,
      ),
      businessTypeDescription: this.resolveOptionDescription(
        this.businessTypes,
        value?.businessType,
      ),
      ecDescription: this.resolveOptionDescription(this.ec, value?.ec),
      ecCode: this.resolveOptionDescription(this.ec, value?.ec),
    };
  }
}
